import {useContext} from "react";
import {AppContext} from "@ignitesales/neuro-application/src/neuro-guide/state/index.mjs";
import {useNeuroMessages, useNeuroState, usePages} from "@ignitesales/neuro-application";

/**
 * @typedef ThemeColorConfig
 * @property {string} primaryColor - the primary configured color
 * @property {string} secondaryColor - the secondary configured color
 */
/**
 * @typedef DialogueContextHookValues
 * @property {Function} getPagePathMessageId - returns page or path message ID based on current survey page
 * @property {ThemeColorConfig} themeColors - returns color configurations
 */
/**
 *
 * @returns {DialogueContextHookValues}
 */
const useDialogueContext = () => {
    const { themeColors } = useNeuroState();
    const { getCurrentPage } = usePages();
    const { hasMessage } = useNeuroMessages();
    const currentPage = getCurrentPage();

    const getPagePathMessageId = () => {
        const pathKey = currentPage?.path?.key;
        const pageKey = currentPage?.page?.key;
        const pageMessageId = `sidebar.${pathKey}.${pageKey}.text`;
        const pathMessageId = `sidebar.${pathKey}.text`;
        return hasMessage(pageMessageId) ? pageMessageId : pathMessageId;
    };

    return {
        getPagePathMessageId,
        themeColors
    };
};

export { useDialogueContext };
